import React from "react";
const AppContext = React.createContext({
    isLoading: false,
    step:1,
    handleStep:()=>{},
    handleLoading:()=>{},

});
export default AppContext;